var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"snackbar",attrs:{"name":"snack","tag":"ul"}},_vm._l((_vm.snackbars),function(item){return _c('li',{key:item.id,staticClass:"snackbar__item",style:(item.color)},[_vm._v("\n        "+_vm._s(item.message)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }